import { NavigateRoutes, RequestType, StatementType, TransactionStatus } from 'common/constants/app.constant';
import { CoBrandingApiQueryParams } from '../pagemodels/co-branding/co-branding.model';
import { QueryParams } from './list.model';

export class TabItemModel {
    id: number;
    image: string;
    name: string;
    selected: boolean;
    routerData?: any;
    routeTo: string;
    show: boolean;
}

export class TabInfoModel {
    tabInfo: TabItemModel[] = [

        {
            id: 2,
            image: 'assets/icon/tabs/transaction.svg',
            name: 'Transact',
            routeTo: NavigateRoutes.initiateTransaction,
            selected: false,
            show: true,
        },
                {
            id: 1,
            image: 'assets/icon/tabs/home.svg',
            name: 'Home',
            routeTo: NavigateRoutes.distributordashboard,
            selected: true,
            show: true,
        },
        {
            id: 3,
            image: 'assets/icon/tabs/cobranding.svg',
            name: 'Cobranding',
            routeTo: NavigateRoutes.coBranding,
            routerData: {
                apiParams: new CoBrandingApiQueryParams(),
            },
            selected: false,
            show: true,
        },
        {
            id: 4,
            image: 'assets/icon/tabs/investor.svg',
            name: 'Investors',
            routeTo: NavigateRoutes.investorList,
            routerData: {
                curruntActiveList: 'investor',
            },
            selected: false,
            show: true,
        },
        {
            id: 5,
            image: 'assets/icon/tabs/prostart.svg',
            name: 'Prostart',
            routeTo: NavigateRoutes.prostartVideos,
            routerData: {
                curruntActiveList: 'prostart',
            },
            selected: false,
            show: true,
        },
    ];
}

export class SideMenuItem {
    id: number;
    name: string;
    url: string;
    iconPath?: string;
    routerData?: any;
    subItems: SideMenuItem[];
    requestType: RequestType;
    selected: boolean = false;
    show: boolean = true;
    isdeepLink?: boolean = false;
}
export class SideMenuModel {
    sideMenuInfo: SideMenuItem[] = [
        {
            id: 0,
            name: 'Home',
            url: NavigateRoutes.distributordashboard,
            iconPath: 'assets/icon/tabs/home.svg',
            subItems: [],
            requestType: RequestType.ID,
            selected: false,
            show: true,
        },
        {
            id: 1,
            name: 'Transaction',
            url: 'SelectTransaction',
            iconPath: 'assets/icon/tabs/transaction.svg',
            subItems: [
                {
                    id: 1,
                    name: 'Initiate Transaction',
                    url: NavigateRoutes.initiateTransaction,
                    iconPath: 'assets/icon/tabs/transaction.svg',
                    subItems: [],
                    requestType: RequestType.BLANK,
                    selected: false,
                    show: true,
                    isdeepLink: true,
                },

                {
                    id: 1,
                    name: 'Transaction History',
                    url: NavigateRoutes.transactionHistory,
                    iconPath: 'assets/icon/tabs/transaction.svg',
                    subItems: [],
                    requestType: RequestType.GET,
                    selected: false,
                    show: true,
                    isdeepLink: true,
                },
            ],
            requestType: RequestType.BLANK,
            selected: false,
            show: true,
            isdeepLink: true,
        },

        {
            id: 2,
            name: 'List',
            url: NavigateRoutes.investor,
            iconPath: 'assets/icon/tabs/list.svg',
            subItems: [
                {
                    id: 1,
                    name: 'Client List',
                    url: NavigateRoutes.investorList,
                    routerData: {
                        curruntActiveList: 'investor',
                    },
                    subItems: [],
                    requestType: RequestType.GET,
                    selected: false,
                    show: true,
                    isdeepLink: true,
                },
                {
                    id: 2,
                    name: 'Scheme Level AUM',
                    url: NavigateRoutes.schemeList,
                    routerData: {
                        curruntActiveList: 'scheme',
                    },
                    subItems: [],
                    requestType: RequestType.GET,
                    selected: false,
                    show: true,
                    isdeepLink: true,
                },
            ],
            requestType: RequestType.ID,
            selected: false,
            show: true,
            isdeepLink: false,
        },
        {
            id: 3,
            name: 'Opportunities',
            url: NavigateRoutes.oppotunity,
            iconPath: 'assets/icon/tabs/opportunities.svg',
            subItems: [],
            requestType: RequestType.BLANK,
            selected: false,
            show: true,
        },
        {
            id: 4,
            name: 'Prostart',
            url: NavigateRoutes.prostartVideos,
            iconPath: 'assets/icon/tabs/prostart.svg',
            subItems: [],
            requestType: RequestType.GET,
            selected: false,
            show: true,
            isdeepLink: true,
        },
        {
            id: 5,
            name: 'Co-branding',
            url: NavigateRoutes.coBranding,
            iconPath: 'assets/icon/tabs/cobranding.svg',
            routerData: {
                apiParams: new CoBrandingApiQueryParams(),
            },
            subItems: [],
            requestType: RequestType.GET,
            selected: false,
            show: true,
            isdeepLink: true,
        },
        {
            id: 6,
            name: 'Statement',
            url: NavigateRoutes.statement,
            iconPath: 'assets/icon/tabs/statements.svg',
            subItems: [
                {
                    id: 1,
                    name: 'Account Statement',
                    url: NavigateRoutes.accountStatement,
                    routerData: {
                        statement: true,
                        typeofStatement: StatementType.account,
                    },
                    subItems: [],
                    requestType: RequestType.ID,
                    selected: false,
                    show: true,
                    isdeepLink: true,
                },
                {
                    id: 2,
                    name: 'Capital Gain Statement',
                    url: NavigateRoutes.capitalGainStatement,
                    routerData: {
                        statement: true,
                        typeofStatement: StatementType.capitalGain,
                    },
                    subItems: [],
                    requestType: RequestType.ID,
                    selected: false,
                    show: true,
                    isdeepLink: true,
                },
            ],
            requestType: RequestType.ID,
            selected: false,
            show: true,
            isdeepLink: true,
        },
        //changed brokeragereport routes to add rate card functionality
        {
            id: 7,
            name: 'Brokerage Report',
            url: NavigateRoutes.brokeragereportpayout,
            iconPath: 'assets/icon/tabs/statements.svg',
            subItems: [
                // {
                //     id: 1,
                //     name: 'Brokerage Payout',
                //     url: NavigateRoutes.brokeragereport,
                //     routerData: {
                //         curruntActiveList: 'brokeragepayout',
                //     },
                //     subItems: [],
                //     requestType: RequestType.GET,
                //     selected: false,
                //     show: true,
                //     isdeepLink: true,
                // },
                // {
                //     id: 2,
                //     name: 'Rate Card',
                //     url: NavigateRoutes.ratecard,
                //     routerData: {
                //         curruntActiveList: 'ratecard',
                //     },
                //     subItems: [],
                //     requestType: RequestType.GET,
                //     selected: false,
                //     show: true,
                //     isdeepLink: true,
                // },
            ],
            requestType: RequestType.GET,
            selected: false,
            show: true,
            isdeepLink: true,
        },
        {
            id: 8,
            name: 'Wishes',
            url: NavigateRoutes.wishes,
            iconPath: 'assets/icon/tabs/birthday-wishes.svg',
            subItems: [],
            requestType: RequestType.ID,
            selected: false,
            show: true,
        },
        {
            id: 9,
            name: 'Feedback & queries',
            url: NavigateRoutes.feedBackAndQuery,
            iconPath: 'assets/icon/tabs/feedback-queries.svg',
            subItems: [],
            requestType: RequestType.GET,
            selected: false,
            show: true,
            isdeepLink: true,
        },
        {
            id: 10,
            name: 'Profile',
            url: NavigateRoutes.distributorprofile,
            iconPath: 'assets/icon/tabs/profile.svg',
            subItems: [],
            requestType: RequestType.GET,
            selected: false,
            show: true,
        },
        {
            id: 11,
            name: 'NAV',
            url: NavigateRoutes.nav,
            iconPath: 'assets/icon/tabs/nav.svg',
            subItems: [],
            requestType: RequestType.GET,
            selected: false,
            show: true,
            isdeepLink: true,
        },
        {
            id: 12,
            name: 'Notifications',
            url: NavigateRoutes.notifications,
            iconPath: 'assets/images/header/notification-bell-grey.svg',
            subItems: [],
            requestType: RequestType.ID,
            selected: false,
            show: true,
        },
        // {
        //     id: 12,
        //     name: 'Bank Mandate',
        //     url: NavigateRoutes.bankMandateListing,
        //     iconPath: 'assets/icon/tabs/prostart.svg',
        //     routerData: {
        //         bankMandate: true,
        //     },
        //     subItems: [],
        //     requestType: RequestType.GET,
        //     selected: false,
        //     show: true,
        //     isdeepLink: true,
        // },
        // {
        //     id: 13,
        //     name: 'Nominee Details',
        //     url: NavigateRoutes.nomineeDetails,
        //     iconPath: 'assets/icon/tabs/prostart.svg',
        //     routerData: {
        //         bankMandate: true,
        //     },
        //     subItems: [],
        //     requestType: RequestType.BLANK,
        //     selected: false,
        //     show: true,
        //     isdeepLink: true,
        // },
    ];
}
